import React, { useEffect } from 'react';
import CreateCloudfrontUrl from '../../services/CreateCloudfrontUrl';
import './ImageModal.css';

const ImageModal = ({ images, currentIndex, onClose, onNext, onPrev }) => {
    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            } else if (e.key === 'ArrowLeft' && currentIndex > 0) {
                onPrev();
            } else if (e.key === 'ArrowRight' && currentIndex < images.length - 1) {
                onNext();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [currentIndex, images.length, onClose, onNext, onPrev]);

    // Prevent body scroll when modal is open
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    if (!images || images.length === 0 || currentIndex < 0 || currentIndex >= images.length) {
        return null;
    }

    const currentImage = images[currentIndex];
    const imageUrl = CreateCloudfrontUrl(currentImage.image);

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                <button
                    className="image-modal-close"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    ×
                </button>

                <div className="image-modal-body">
                    <img
                        src={imageUrl}
                        alt={currentImage.alt}
                        className="image-modal-image"
                    />

                    {currentImage.description && (
                        <p className="image-modal-description">
                            {currentImage.description}
                        </p>
                    )}
                </div>

                {images.length > 1 && (
                    <div className="image-modal-navigation">
                        <button
                            className="image-modal-nav-button image-modal-prev"
                            onClick={onPrev}
                            disabled={currentIndex === 0}
                            aria-label="Previous image"
                        >
                            ‹
                        </button>

                        <span className="image-modal-counter">
                            {currentIndex + 1} / {images.length}
                        </span>

                        <button
                            className="image-modal-nav-button image-modal-next"
                            onClick={onNext}
                            disabled={currentIndex === images.length - 1}
                            aria-label="Next image"
                        >
                            ›
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageModal;
